import { mount } from "svelte";
import "./app.css";
import App from "./App.svelte";
import * as Sentry from "@sentry/svelte";

Sentry.init({
  dsn: "https://74a725d1ee62fd92c2285534fd04226d@o106966.ingest.us.sentry.io/4509332046610432",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // High-volume expected hotspot empty states (missing MAC / flaky node.html)
  // previously burned through quota as full exceptions.
  ignoreErrors: [
    /^Missing MAC address for voucher load/i,
    /^Invalid MAC address/i,
    /^MAC address missing/i,
    /^An error occured while getting info/i,
  ],
  beforeSend(event) {
    const message =
      event.message ||
      event.exception?.values?.[0]?.value ||
      "";
    if (
      /Missing MAC address for voucher load/i.test(message) ||
      /MAC address missing/i.test(message) ||
      /Invalid MAC address/i.test(message)
    ) {
      return null;
    }
    return event;
  },
});

const app = mount(App, {
  target: document.getElementById("app"),
});

export default app;
